import {
  CLEAR_SHIP_OPTIONS_BY_GROUP,
  RECEIVE_NEW_SHIP_OPTIONS_FIELD,
  SET_CHECKOUT_SHIP_OPTIONS,
  STORE_SHIP_OPTIONS_BY_GROUP,
  STORE_SHIP_OPTIONS_FOR_EGC_ONLY_CART
} from 'constants/reduxActions';
import {
  SHIP_OPTION_GROUP_RETAIL_W_OPTIONS
} from 'constants/shipOptionGroups';

import { determineGroupType } from 'helpers/CheckoutUtils';

export function receiveCheckoutShipOptions(data) {
  return { type: SET_CHECKOUT_SHIP_OPTIONS, data };
}

export function receiveNewShipOptionsField(fieldKey, fieldValue) {
  return { type: RECEIVE_NEW_SHIP_OPTIONS_FIELD, fieldKey, fieldValue };
}

export function breakShipOptionsOutByGroup() {
  return function (dispatch, getState) {
    const { checkoutData } = getState();
    const {
      purchaseData: { productsByLineItem },
      shipOptions: { byLineItem = [], groups = {} }
    } = checkoutData;

    let hasStoredShipOptionsForRetailNonHazmat = false;

    byLineItem.forEach(group => {
      const groupType = determineGroupType(productsByLineItem, group);

      // we only care about this group, as this is the group that should be shown
      // when user is on the modal (/checkout/shipoption)
      // in event that we support multiple ship options on a single purchase in the
      // future, this will need some re-work
      if (groupType === SHIP_OPTION_GROUP_RETAIL_W_OPTIONS) {
        hasStoredShipOptionsForRetailNonHazmat = true;
        dispatch({ type: STORE_SHIP_OPTIONS_BY_GROUP, groupType, group });
      }
    });

    // if has no groups, need to clear out the retail group in case that
    // one previously existed on the purchase (aka, started with east coast
    // address and then picked a west coast address when had hazmat item)
    if (!hasStoredShipOptionsForRetailNonHazmat && groups.hasOwnProperty(SHIP_OPTION_GROUP_RETAIL_W_OPTIONS)) {
      dispatch({ type: CLEAR_SHIP_OPTIONS_BY_GROUP });
    }
  };
}

// if there is only 1 item on the purcahse, and its an EGC, then we need
// to fudge the data as mafia will not return an empty ship options set
// in this case, but only if its a mixed cart
export function storeEGCOnlyShipOptions() {
  return function (dispatch, getState) {
    const { checkoutData } = getState();
    const {
      purchaseData: { productsByLineItem = {} }
    } = checkoutData;

    const productsByLineItemKeys = Object.keys(productsByLineItem);

    if (productsByLineItemKeys.length === 1) {
      const lineItemId = productsByLineItemKeys[0];
      if (productsByLineItem[lineItemId].gcCustomization !== null) {
        const byLineItem = [
          {
            lineItemIds: [lineItemId],
            deliveryOptions: []
          }
        ];
        dispatch({ type: STORE_SHIP_OPTIONS_FOR_EGC_ONLY_CART, byLineItem });
      }
    }
  };
}
